import {createStore} from 'trim-redux'
const state = {
    navCollapsed : false,
    isAuth : false,
    user : null,
    dashboard : null,
    cart: [],

};
export const store = createStore(state);